import salexMark from '../assets/salex-s.png';
import styles from './PoweredBy.module.css';

/** Crédito a Corp Salex. `tone="inverse"` sobre fondos oscuros. */
export function PoweredBy({ tone = 'default' }: { tone?: 'default' | 'inverse' }) {
  return (
    <p className={`${styles.credit} ${tone === 'inverse' ? styles.inverse : ''}`}>
      <span>Powered by</span>
      {/* Solo la S de Salex; el nombre queda como texto alternativo para lectores de pantalla. */}
      <img className={styles.mark} src={salexMark} alt="Salex" width={122} height={144} />
    </p>
  );
}
